import { createState, css, Stateful, type Component } from "dreamland/core";
import { router } from "dreamland/router";
import { getFederatedTimeline, getHomeTimeline, getLocalTimeline, TimelineType } from "../api/timelines";
import { Status, auth } from "../api";
import StatusView from "../components/Status";

const Timeline: Component<{type: TimelineType}, {name: string;}> = function (cx) {
    let state: Stateful<{
        statuses: Status[];
    }> = createState({
        statuses: [] 
    });

    const loadTimeline = async (params: any = {}) => {
        let fetchedStatuses: Status[] = [];
        
        switch (this.type) {
            case "home":
                this.name = "Home";
                fetchedStatuses = await getHomeTimeline(params);
                break;
            case "local":
                this.name = "Local";
                fetchedStatuses = await getLocalTimeline(params);
                break;
            case "federated":
                this.name = "Federated";
                fetchedStatuses = await getFederatedTimeline(params);
                break;
            case "hashtag":
            default:
                this.name = "Timeline";
                break;
        }
        
        state.statuses = fetchedStatuses;
        window.scrollTo(0, 0);
    }
    
    cx.mount = async () => {
        // Check auth before loading timeline
        if (!auth.isAuthenticated()) {
            router.navigate("/login");
            return;
        }

        await loadTimeline();
    }

    const loadNext = () => {
        if (state.statuses.length === 0) return;
        const lastStatus = state.statuses[state.statuses.length - 1];
        loadTimeline({ max_id: lastStatus.id });
    }

    const loadPrev = () => {
        if (state.statuses.length === 0) return;
        const firstStatus = state.statuses[0];
        loadTimeline({ min_id: firstStatus.id });
    }

	return (
		<div class="page">
            <h1>{use(this.name)}</h1>
			{use(state.statuses).mapEach((status) => (
                <>
                    <StatusView status={status} />
                    <hr />
                </>
            ))}
            <div class="pagination">
                <a on:click={loadPrev}>&laquo; Prev</a>
                <a on:click={loadNext}>Next &raquo;</a>
            </div>
		</div>
	);
};

Timeline.style = css`
    hr {
        color: black!important;
        margin: 16px 0;
    }

    .pagination {
        display: flex;
        justify-content: space-between;
        margin: 16px 0;
    }
`;

export default Timeline;